export const SORT_OPTIONS = [
  { value: 'PLATE_ASC', label: 'Plate # (Low → High)' },
  { value: 'PLATE_DESC', label: 'Plate # (High → Low)' },
  { value: 'TITLE_ASC', label: 'Image Title (A-Z)' },
  { value: 'TITLE_DESC', label: 'Image Title (Z-A)' },
];

export const getDirectusSort = sortKey => {
  switch (sortKey) {
    case 'PLATE_ASC':  return 'plate';
    case 'PLATE_DESC': return '-plate';
    case 'TITLE_ASC':  return 'image_title';
    case 'TITLE_DESC': return '-image_title';
    default:           return '-id';
  }
};

export const getSortLabel = directusSort => {
  const found = SORT_OPTIONS.find(opt => getDirectusSort(opt.value) === directusSort);
  return found ? found.label : null;
};

export const formatPlate = value =>
  value !== null && value !== undefined && value !== '' ? value : '-';
